<template>
  <div id="noticelist">
    <router-link target="_blank" :to="{path:'/noticedetail',query:{id:listdate.id,type:type}}"
      class="li point pb-30 flex ai-center"
      :class="index == noticeindex ? 'bg-colfa activetransform' : ''"
    >
      <div class="time mt-30 mr-20 ml-20">
        <img class="img" src="../../assets/image/timecon.png" alt="" />
        <div class="fontcon flex jc-center">
          <div class="left fs-18 color-fontcol3 text-center mt-15">{{listdate.month}}</div>
          <div class="right fs-18 color-fontcol3 text-center mt-30">{{listdate.day}}</div>
        </div>
      </div>
      <div class="allcon">
        <div
          class="text-ellipsis fs-18 recruittop pt-35 pl-10 pr-10 flex jc-betweet ai-center"
          :class="index == noticeindex ? 'color-active' : 'color-fontcol3'"
        >
          {{ listdate.title }}
        </div>
        <div class="recruitbot ml-15 text-ellipsis2 color-fontcol9 fs-14 mt-5">
          {{ listdate.intro }}
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "newmodel",
  props: ["listdate", "noticeindex", "index","type"],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#noticelist {
  width: 100%;
  margin: auto;
  .li {
    width: 100%;
    border-bottom: 1px solid #ededed;
    transition: all 0.3s ease;
    .time {
      width: 72px;
      height: 72px;
      position: relative;
      .img {
        width: 100%;
        height: 100%;
      }
      .fontcon {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        .left {
          width: 49%;
          height: 100%;
        }
        .right {
          width: 49%;
          height: 100%;
        }
      }
    }
    .allcon {
      width: 80%;
      .recruitbot {
        width: 93%;
        height: 55px;
        padding: 0;
      }
    }
  }
  .pagination {
    .btn {
      width: 60px;
      height: 24px;
    }
  }
}
</style>
